export default __webpack_public_path__ + "static/media/logo_.9cbff267.png";